import * as React from "react";
const SvgCalendar = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M17.833 3.667H17v-.834a.833.833 0 1 0-1.667 0v.834H8.667v-.834a.833.833 0 1 0-1.667 0v.834h-.833A4.17 4.17 0 0 0 2 7.833v10A4.17 4.17 0 0 0 6.167 22h11.666A4.17 4.17 0 0 0 22 17.833v-10a4.17 4.17 0 0 0-4.167-4.166M6.167 5.333h11.666c1.379 0 2.5 1.122 2.5 2.5v.834H3.667v-.834c0-1.378 1.121-2.5 2.5-2.5m11.666 15H6.167a2.503 2.503 0 0 1-2.5-2.5v-7.5h16.666v7.5c0 1.379-1.121 2.5-2.5 2.5"
  }
));
export default SvgCalendar;
